import {createAction} from 'Shared/utilities/actionCreator';
import * as I from 'Users/models/User/Agent/IamUserType';

export enum IamUserTypeActionType {
  CHANGE_AHL_ACCESS = 'iamUserType/CHANGE_AHL_ACCESS',
  CHANGE_NEW_YORK_ACCESS = 'iamUserType/CHANGE_NEW_YORK_ACCESS',
  CHANGE_IS_EXTERNAL_ADMIN = 'iamUserType/CHANGE_IS_EXTERNAL_ADMIN',
}

export const changeHasAHLAccess = (hasAhlAccess: boolean) =>
  createAction(IamUserTypeActionType.CHANGE_AHL_ACCESS, {hasAhlAccess});
export const changeHasNewYorkAccess = (hasNewYorkAccess: boolean) =>
  createAction(IamUserTypeActionType.CHANGE_NEW_YORK_ACCESS, {hasNewYorkAccess});
export const changeIsExternalAdmin = (isExternalAdmin: boolean) =>
  createAction(IamUserTypeActionType.CHANGE_IS_EXTERNAL_ADMIN, {isExternalAdmin});

export type IAMUserTypeAction =
  | ReturnType<typeof changeHasAHLAccess>
  | ReturnType<typeof changeHasNewYorkAccess>
  | ReturnType<typeof changeIsExternalAdmin>;

type IAMUserTypeState = I.IAMUserType;
const DEFAULT_STATE: IAMUserTypeState = I.DefaultIAMUserType;

export default (state: IAMUserTypeState = DEFAULT_STATE, action: IAMUserTypeAction): IAMUserTypeState => {
  switch (action.type) {
    case IamUserTypeActionType.CHANGE_IS_EXTERNAL_ADMIN:
      return I.changeIsExternalAdministrator(action.payload.isExternalAdmin)(state);
    case IamUserTypeActionType.CHANGE_AHL_ACCESS:
      return I.changeHasAhlAccess(action.payload.hasAhlAccess)(state);
    case IamUserTypeActionType.CHANGE_NEW_YORK_ACCESS:
      return I.changeNewYorkAccess(action.payload.hasNewYorkAccess)(state);
    default:
      return state;
  }
};
